"use client";

import { useEffect } from "react";
import Lenis from "lenis";

export default function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.5, // Increased duration for "heavier" feel
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: "vertical", // 'direction' was deprecated/wrong in types, 'orientation' is correct usually for newer versions or just standard
      gestureOrientation: "vertical",
      smoothWheel: true,
      wheelMultiplier: 1.2, // increased multiplier
      touchMultiplier: 2,
    });

    function raf(time: number) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();
        const href = anchor.getAttribute("href");
        if (href) {
          lenis.scrollTo(href);
        }
      });
    });

    return () => {
      lenis.destroy();
    };
  }, []);

  return null;
}
